<flx-heading type="page" size="medium">Job Summary</flx-heading>

<ng-container>
	<flx-heading size="small" color="secondary">Job Details</flx-heading>
	<flx-key-value-list [data$]="jobDetails$ | async" align="left" width="110px"></flx-key-value-list>

	<flx-heading size="small" color="secondary">Customer</flx-heading>
	<flx-key-value-list [data$]="customerDetails$" align="left" width="110px"></flx-key-value-list>
</ng-container>
